import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { UI, t } from "@/i18n/translations";

export function LegalConsentText() {
  const { lang } = useLang();
  const L = UI.legal;
  return (
    <>
      {t(L.accept, lang)}{" "}
      <Link to="/legal/terms" target="_blank" data-testid="link-terms" className="font-semibold text-sage underline">{t(L.terms, lang)}</Link>{" "}
      {t(L.and, lang)}{" "}
      <Link to="/legal/privacy" target="_blank" data-testid="link-privacy" className="font-semibold text-sage underline">{t(L.privacy, lang)}</Link>.
    </>
  );
}
